import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getGlobalStats } from "@/api/stats";
import { num, pct100 } from "./format";
import { StatsBanner } from "./stats-banner";

/**
 * Compact "Across EduPause" band for the Library tab. Mirrors the Global sub-tab
 * header on the Stats page and reuses its exact query key (["global-stats", null])
 * so the cache — and therefore the numbers — are shared, not duplicated.
 */
export function GlobalStatsBanner() {
  const { t } = useTranslation();
  const global = useQuery({
    queryKey: ["global-stats", null],
    queryFn: () => getGlobalStats(),
  });
  const g = global.data;

  // Silently hide on error — the banner is a non-critical shortcut, not core content.
  if (global.isError) return null;

  return (
    <StatsBanner
      title={t("Across EduPause")}
      to="/app/stats?tab=global"
      cta={t("Explore global stats")}
      loading={global.isLoading}
      tiles={[
        { label: t("Active learners"), value: num(g?.total_active_users) },
        { label: t("Questions answered"), value: num(g?.total_questions_answered) },
        { label: t("Overall accuracy"), value: pct100(g?.overall_accuracy_percent) },
        { label: t("Sets generated"), value: num(g?.total_sets_generated) },
      ]}
    />
  );
}
